import { render, staticRenderFns } from "./index.vue?vue&type=template&id=de3b0036&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=de3b0036&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de3b0036",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('de3b0036')) {
      api.createRecord('de3b0036', component.options)
    } else {
      api.reload('de3b0036', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=de3b0036&scoped=true", function () {
      api.rerender('de3b0036', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/wovenBagManagement/recyclingManagement/index.vue"
export default component.exports